/** Active shield styling shared with send-to-signers tier toggle. */
export const verificationShieldActiveClassName =
  'text-primary border-primary/25 bg-primary/10';
